"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _LogStore = _interopRequireDefault(require("./LogStore2"));

var LogActions = /*#__PURE__*/function () {
  function LogActions() {
    (0, _classCallCheck2["default"])(this, LogActions);
  }

  (0, _createClass2["default"])(LogActions, null, [{
    key: "logMessageEnqueueAction",
    value: function logMessageEnqueueAction(message) {
      _LogStore["default"].logMessageDequeueAction(message);
    }
  }, {
    key: "logMessageDequeueAction",
    value: function logMessageDequeueAction(message) {
      _LogStore["default"].logMessageDequeueAction(message);
    }
  }]);
  return LogActions;
}();

var _default = LogActions;
exports["default"] = _default;